import { Modal } from '@/components/ui/Modal';

interface AdblockModalProps {
  open: boolean;
  onClose: () => void;
}

export function AdblockModal({ open, onClose }: AdblockModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Ads are blocked">
      <section className="privacy-section">
        <p>
          It looks like an ad blocker, privacy browser, or network filter is preventing the ad from
          loading. Slime Pang is free to play because ads support development &mdash; please
          consider whitelisting <strong>slimepang.com</strong> and refreshing the page to claim your
          reward.
        </p>
      </section>
      <section className="privacy-section">
        <p>
          On Brave: click the Shields icon in the address bar and lower it for this site. On uBlock
          Origin / AdBlock: open the extension and disable it for slimepang.com.
        </p>
      </section>
      <section className="privacy-section">
        <p>Thanks for supporting the game!</p>
      </section>
    </Modal>
  );
}
